import { render, staticRenderFns } from "./logoWhiteMobile.vue?vue&type=template&id=f80db96a&"
import script from "./logoWhiteMobile.vue?vue&type=script&lang=js&"
export * from "./logoWhiteMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports